import { createSlice } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from 'services/api';
import { logout } from './userSlice';

export const initialState = {
  appointmentRequests: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  current_page: 1,
  per_page: PAGELENGTH,
};

export const appointmentRequestSlice = createSlice({
  name: 'appointmentRequest',
  initialState: initialState,
  reducers: {
    setAppointmentRequests: (state, { payload }) => {
      state.appointmentRequests = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    removeAppointmentRequest: (state, { payload }) => {
      state.error = payload;
    },
    clearAllAppointmentRequests: (state, { payload }) => {
      state.loader = payload;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setLoader: (state, { payload }) => {
      state.loader = payload;
    },
  },
});

export const fetchAppointmentRequests = (page, params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true));
  try {
    const result = await Api.fetchAppointmentRequests(page, params);
    if (result.status >= 200 && result.status < 300) {
      dispatch(setAppointmentRequests(result.data.data));
    } else if (result?.status == 422) {
      dispatch(setError(result.data));
    } else if (result?.status == 401) {
      dispatch(setError('Unauthorized'));
      dispatch(logout());
    }
  } catch (error) {
    console.log('error', error);
  }
  !disableLoader && dispatch(setLoader(false));
};

export const fetchClientAppointmentRequests = (page, params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true));
  try {
    const result = await Api.fetchClientAppointmentRequests(page, params);
    if (result.status >= 200 && result.status < 300) {
      dispatch(setAppointmentRequests(result.data.data));
    } else if (result?.status == 422) {
      dispatch(setError(result.data));
    } else if (result?.status == 401) {
      dispatch(setError('Unauthorized'));
      dispatch(logout());
    }
  } catch (error) {
    console.log('error', error);
  }
  !disableLoader && dispatch(setLoader(false));
};

export const {
  setAppointmentRequests,
  removeAppointmentRequest,
  clearAllAppointmentRequests,
  setError,
  setLoader,
} = appointmentRequestSlice.actions;

export default appointmentRequestSlice.reducer;
export const appointmentRequestSelector = (state) => state.appointmentRequest;
